import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import CropViewer from './pages/cropsViewer/CropViewer';
import AdminViewer from './pages/admin/AdminViewer';
import Queued from './pages/admin/Queued';
import UserList from './pages/admin/UserList';
import CropOutput from './pages/admin/CropOutput';
import TillageUpload from './pages/admin/TillageUpload';
import { useRecoilValue } from 'recoil';
import globalState from 'state/globalState';

function Router() {
  const auth = useRecoilValue(globalState);

  return (
    <Routes>
      <Route
        element={<CropViewer />}
        path="/ffis2ai"
      />
   
    
    </Routes>
  );
}

export default Router;
